import { Actor } from "../actors/Actor";

export enum ActionSpeed {
  SLOW,
  MEDIUM,
  FAST,
}

export type ActionResult = {
  valid: boolean;
};

export type Performer<T> = (
  actor: Actor,
  options: T
) => ActionResult | Promise<ActionResult>;

export type Action<T> = {
  actor: Actor;
  options: T;
  perform: Performer<T>;
  speed?: ActionSpeed;
};

export function createAction<T>(
  performer: Performer<T>,
  actor: Actor,
  options: T,
  speed = ActionSpeed.MEDIUM
): Action<T> {
  return {
    perform: performer,
    options,
    actor,
    speed,
  };
}

export function runAction<T>(action: Action<T>) {
  if (action.actor.alive && !action.actor.status.staggered) {
    return action.perform(action.actor, action.options);
  }
}
